import { ref, onMounted } from 'vue';
import { copyToClipboard } from '~/app/lib/copyToClipboard';

enum Social {
  LINKEDIN = 'Linkedin',
  FACEBOOK = 'Facebook',
  TWITTER = 'Twitter',
  COPY = 'Copy',
}

export const useSocialShare = (customTitle?: string, customDescription?: string) => {
  const SocialInfo = {
    [Social.FACEBOOK]: {
      title: Social.FACEBOOK,
      icon: Social.FACEBOOK,
      basicLink: 'https://www.facebook.com/sharer/sharer.php?u=',
    },
    [Social.LINKEDIN]: {
      title: Social.LINKEDIN,
      icon: Social.LINKEDIN,
      basicLink: 'https://www.linkedin.com/sharing/share-offsite/?url=',
    },
    [Social.TWITTER]: {
      title: Social.TWITTER,
      icon: 'X_icon',
      basicLink: 'https://twitter.com/share?url=',
    },
    [Social.COPY]: {
      title: Social.COPY,
      icon: 'Link',
      basicLink: '',
    },
  };

  const socialLinksArray = Object.values(SocialInfo);
  const metaPageTitle = ref<string | undefined>(customTitle);
  const metaPageDescription = ref<string | undefined>(customDescription);
  const completeUrl = ref<string>('');

  onMounted(() => {
    if (!metaPageTitle.value) {
      const titleElement = document.querySelectorAll('meta[property="og:title"]')[0] as HTMLMetaElement;
      metaPageTitle.value = titleElement?.content;
    }

    if (!metaPageDescription.value) {
      const descElement = document.querySelectorAll('meta[property="og:description"]')[0] as HTMLMetaElement;
      metaPageDescription.value = descElement?.content;
    }

    completeUrl.value = window.location.href;
  });

  const shareLink = encodeURIComponent(completeUrl.value);
  const title = metaPageTitle.value && encodeURIComponent(metaPageTitle.value);
  const description = metaPageDescription.value && encodeURIComponent(metaPageDescription.value);

  const openShareWindow = (linkTitle: Social) => {
    const basicLink = SocialInfo[linkTitle].basicLink;
    let linkUrl = '';

    if (linkTitle === Social.LINKEDIN) {
      linkUrl = `${basicLink}${completeUrl.value}`;
    } else if (linkTitle === Social.TWITTER) {
      linkUrl = `${basicLink}${shareLink}/&title=${title}&summary=${description}`;
    } else if (linkTitle === Social.FACEBOOK) {
      linkUrl = `${basicLink}${shareLink}&quote=${title}`;
    } else if (linkTitle === Social.COPY) {
      copyToClipboard(completeUrl.value);
    }
    linkTitle !== Social.COPY && window.open(linkUrl, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
  };

  const isThereNativeDeviceMenu = navigator && navigator.share !== undefined;
  const showDesktopVersion = socialLinksArray.length > 0 && !isThereNativeDeviceMenu;

  const openNativeDeviceMenu = () => {
    navigator.share({
      title: metaPageTitle.value,
      text: metaPageDescription.value,
      url: completeUrl.value,
    });
  };

  return {
    socialLinksArray,
    openShareWindow,
    isThereNativeDeviceMenu,
    openNativeDeviceMenu,
    showDesktopVersion,
  };
};
